import { Link } from '@remix-run/react'
import { User, MessageSquare, ArrowRightIcon } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from '#app/components/ui/card.tsx'
import { type CategorizedSections } from './categorizeSection'
import { DayCardContent } from './DayCardContent'

export interface DayCardProps {
  id: string
  uniqueSpeakers: number
  speeches: { id: string }[]
  categorizedSections: CategorizedSections
}

export function DayCard({ day }: { day: DayCardProps }) {
  const title = new Date(day.id).toLocaleDateString('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  return (
    <Card className="flex h-full flex-col">
      <CardHeader>
        <Link to={`/hansard/${day.id}`}>
          <h2 className="text-lg font-bold">{title}</h2>
        </Link>
      </CardHeader>
      <CardContent className="flex-grow">
        <DayCardContent
          id={day.id}
          categorizedSections={day.categorizedSections}
        />
      </CardContent>
      <CardFooter className="flex justify-between text-sm text-gray-600">
        <div className="flex items-center">
          <User className="h-4 w-4" />
          <span>{day.uniqueSpeakers} MPs</span>
        </div>
        <div className="ml-1 flex items-center border-l border-gray-600 pl-1">
          <MessageSquare className="h-4 w-4" />
          <span>{day.speeches.length} speeches</span>
        </div>

        <div className="flex-grow" />

        <div>
          <Link
            className="inline-flex items-center gap-2 text-blue-500 hover:text-blue-600"
            to={`/hansard/${day.id}`}
          >
            View Day
            <ArrowRightIcon className="h-4 w-4" />
          </Link>
        </div>
      </CardFooter>
    </Card>
  )
}
